import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UnitService {

    api_url = environment.url;

    constructor(private http: HttpClient) { }

    addUnit(data: any) {
        return this.http.post(`${this.api_url}unit/add`, data);
    }

    addUnitForm(data: any) {
        const formData = new FormData();
        Object.keys(data).forEach(key => {
            const value = data[key];
            if (value !== null && value !== undefined) {
                formData.append(key, value);
            }
        });
        return this.http.post(`${this.api_url}unit/add`, formData);
    }

    updateUnit(data: any, id: number) {
        return this.http.post(`${this.api_url}unit/update/${id}`, data);
    }

    updateUnitForm(data: any, id: number) {
        const formData = new FormData();
        Object.keys(data).forEach(key => {
            const value = data[key];
            if (value !== null && value !== undefined) {
                formData.append(key, value);
            }
        });
        return this.http.post(`${this.api_url}unit/update/${id}`, formData);
    }

    listUnit() {
        return this.http.get(`${this.api_url}unit/list`)
    }
    getId(id: number) {
        return this.http.get(`${this.api_url}unit/show/${id}`)
    }
    getInfo() {
        return this.http.get(`${this.api_url}unit/getCombo`)
    }
    deleteUnit(id: any) {
        return this.http.get(`${this.api_url}unit/delete/${id}`)
    }

    importUnits(file: File, delimiter?: string, dryRun?: boolean): Observable<HttpEvent<any>> {
        const formData = new FormData();
        formData.append('file', file);
        if (delimiter) {
            formData.append('delimiter', delimiter);
        }
        if (dryRun !== undefined && dryRun !== null) {
            formData.append('dry_run', dryRun ? '1' : '0');
        }

        return this.http.post<any>(`${this.api_url}unit/import`, formData, {
            reportProgress: true,
            observe: 'events',
        });
    }

    exportUnits() {
        return this.http.get(`${this.api_url}unit/export`, {
            responseType: 'blob'
        })
    }

    getPermitTypes() {
        return this.http.get(`${this.api_url}unit/permit-types`)
    }

    getInsurers() {
        return this.http.get(`${this.api_url}unit/insurers`)
    }

    getVehicleConfigurations() {
        return this.http.get(`${this.api_url}unit/vehicle-configurations`)
    }
    crearChecklist(data: any, evidencias: Record<string, File[]>) {
        const formData = new FormData();

        Object.keys(data).forEach(key => {
            if (data[key] !== null && data[key] !== undefined) {
                formData.append(key, data[key]);
            }
        });

        // Adjuntar imágenes agrupadas por categoría
        Object.keys(evidencias).forEach(categoria => {
            evidencias[categoria].forEach(file => {
                formData.append(`images[${categoria}][]`, file);
            });
        });

        return this.http.post(this.api_url + 'unit/checklist', formData);
    }
    getChecklist(id: number) {
        return this.http.get(this.api_url + 'unit/checklist/' + id);
    }
}
